module.exports = __webpack_public_path__ + "static/media/DSC03527.f343b3a6.JPG";